import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class AuthAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Auth";
  controllerName = "users";

  /**
   * Verify AMIS Platform session — gọi backend xác thực SID từ AMIS Platform
   * UpdatedBy: dbhuan (09/06/2026)
   * @param {{ sid: string, tcode?: string, env?: string }} params
   * @returns {Promise<object>} API response
   */
  async amplVerify({ sid, tcode, env }) {
    if (window.__env?.AMPL_API_MOCK) {
      return this._mockAmplVerify({ sid, tcode, env });
    }
    const url = `${window._apis.Auth}/api/account/ampl/verify`;
    return httpClient.postAsync({
      url,
      data: { sid, tcode: tcode || "", env: env || "" },
    });
  }

  /**
   * Logout AMIS Platform session — best-effort
   * UpdatedBy: dbhuan (09/06/2026)
   * @param {{ sid: string }} params
   * @returns {Promise<object>} API response
   */
  async amplLogout({ sid }) {
    if (window.__env?.AMPL_API_MOCK) {
      return { success: true, errorCode: null, errorMessage: null, data: null };
    }
    const url = `${window._apis.Auth}/api/account/ampl/logout`;
    return httpClient.postAsync({
      url,
      data: { sid },
    });
  }

  /**
   * Mock response cho amplVerify — dùng khi backend chưa sẵn sàng
   * UpdatedBy: dbhuan (09/06/2026)
   */
  _mockAmplVerify({ sid }) {
    if (!sid) {
      return {
        success: false,
        errorCode: "AMPL_SESSION_INVALID",
        errorMessage: "Phiên làm việc không hợp lệ",
        data: { amplLoginUrl: window.__env?.amplLoginUrl || "" },
      };
    }
    if (sid === "invalid-sid") {
      return {
        success: false,
        errorCode: "AMPL_SESSION_INVALID",
        errorMessage: "Phiên làm việc không hợp lệ, vui lòng đăng nhập lại",
        data: { amplLoginUrl: window.__env?.amplLoginUrl || "" },
      };
    }
    return {
      success: true,
      errorCode: null,
      errorMessage: null,
      data: {
        accessToken: "mock-access-token-" + Date.now(),
        refreshToken: "mock-refresh-token-" + Date.now(),
        user: {
          userId: "5c6ee3d8-f045-4015-8fcc-a9ce9eb1013f",
          fullName: "Nguyễn Văn A",
          email: "nguyenvana@misa.com.vn",
          misaId: "fddfd66b-dc4d-43bb-b162-a938b82a7181",
        },
        merchantInfo: {
          merchantCode: "aaa",
          tenantId: "00000000-0000-0000-0000-000000000002",
          tenantName: "Công ty Test",
          taxCode: "012345",
        },
        avatarUrl: "",
      },
    };
  }
}

export default new AuthAPI();
